import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';
// Components
import AppTable from '../../../components/table/index';
import ApiCaller from '../../../services/api/general';
import { showSnackbar } from '../../../components/snackbar/index';
import AppPopOverMenu from '../../../components/appPopOverMenu';
import ConfirmDialog from '../../../components/dialogs/confirm.dialog';
import { DATE_READABLE_FORMAT, DATE_TIME_FORMAT, DATE_ONLY_FORMAT, MONTH_TEXT_FORMAT } from '../../../constants/index';
import AppButton from '../../../components/buttons/app.button';
import TextInput from '../../../components/inputs/textInput/textInput';
import { translateThis } from '../../../helpers/language.helper';
import SVGIcons from '../../../assets/images/icons/svgIcons';
import { downloadDailyLog } from '../../../services/api/pdf';
import { getDynamicFormPreview } from '../../../helpers/dynamicForm.helper';
import ModalPopUp from '../../../components/modal/modal.popup';
import AppIcons from '../../../assets/images/icons';


const DailyLogToSignTab = () => {
    const apiCaller = new ApiCaller('daily-logs');
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [dataArr, setDataArr] = useState([]);
    const [openSubmissionDialog, setOpenSubmissionDialog] = useState(false);
    const [selectedId, setSelectedId] = useState('');
    const [signature, setSignature] = useState('');
    const [viewOpen, setViewOpen] = React.useState(false);
    const [selectedPreview, setSelectedPreview] = React.useState(<></>);


    const onViewClose = () => {
        setViewOpen(false);
    };

    /**
  the legendary use effect function
  This will run very first on render
   */
    useEffect(() => {
        getDataArr()
        return () => {
            setDataArr([])
        };
        // eslint-disable-next-line
    }, []);
    // get users from api
    const getDataArr = () => {
        setIsLoading(true);
        apiCaller.getList()
            .then((data) => {
                if (data) {
                    let dataArray = data?.results || [];
                    dataArray = dataArray.filter((data) => (!data.isProviderSigned || !data.isParentSigned))
                    setDataArr(dataArray)
                }
            })
            .catch((e) => console.log(e))
            .finally(() => setIsLoading(false));

    }



    /**
   * submit Daily Log
   */
    const submitDailyLog = () => {
        if (selectedId && signature) {
            setIsSubmitting(true);
            apiCaller.updateData(selectedId, {
                isParentSigned: true,
                status: 'completed',
                additionalInfo: {
                    isParentSigned: true,
                    parentSignature: signature,
                    parentSignedDate: dayjs().format(DATE_TIME_FORMAT)
                }
            })
                .then(({ success, message }) => success ?
                    showSnackbar().success(`The selected log has been submitted successfully.`)
                    : showSnackbar().warning(message)
                )
                .catch(() => showSnackbar().failure("Something went wrong!."))
                .finally(() => {
                    setOpenSubmissionDialog(false);
                    setIsSubmitting(false);
                    setSelectedId('');
                    setSignature('');
                    getDataArr();
                })
        } else {
            showSnackbar().warning('Please sign the form to submit');
        }

    }

    /**
   * Download Daily Log
   */
    const downloadDailyLogPDF = (id, logTitle) => {
        if (id && logTitle) {
            showSnackbar().info("Selected daily log will be downloaded shortly")
            downloadDailyLog(id, logTitle)
                .then(({ success, message }) => success ?
                    showSnackbar().success(`The selected log has been downloaded successfully.`)
                    : showSnackbar().warning(message)
                )
                .catch(() => showSnackbar().failure("Something went wrong!."))
                .finally(() => {
                })
        } else {
            showSnackbar().warning('Something went wrong!.');
        }

    }

    /**
         * 
         * @param {string} formName 
         * @param {any} formData 
         */
    const onFormPreviewClick = (formName, formData) => {
        const previewSelected = getDynamicFormPreview(formName, { data: formData })
        setViewOpen(true);
        setSelectedPreview(previewSelected);
    }

    /**
     * Columns array to show 
     */
    const tableColumns = [
        {
            field: 'childId',
            headerName: 'Child',
            flex: 1.3,
            minWidth: 120,
            valueFormatter: ({ value }) => `${value?.firstName || ''} ${value?.lastName || ''}`
        },
        {
            field: 'logTitle',
            headerName: 'Communication title',
            flex: 1.3,
            minWidth: 180,
        },
        {
            field: 'logDate',
            headerName: 'Communication Date',
            flex: 1.5,
            minWidth: 160,
            valueGetter: (params) => dayjs(params.row?.logDate).format(DATE_READABLE_FORMAT),
        },
        {
            field: 'submissionDate',
            headerName: 'Submission Date',
            flex: 1,
            minWidth: 140,
            valueGetter: (params) => dayjs(params.row?.submissionDate).format(DATE_READABLE_FORMAT),
        },
        {
            field: 'signatureDate',
            headerName: 'Signature date',
            flex: 1,
            minWidth: 140,
            valueGetter: (params) => dayjs(params.row?.parentSignedDate).format(DATE_READABLE_FORMAT),
        },
        {
            field: 'isParentSigned',
            headerName: 'Parent',
            flex: 1,
            minWidth: 110,
            renderCell: (params) => params.row?.isParentSigned ?
                <span className='complete'><SVGIcons.TickIcon /> Signed</span> :
                <AppButton
                    onClick={() => {
                        setOpenSubmissionDialog(true);
                        setSelectedId(params.row?.id);
                    }}
                    btnText='Sign'
                />,
        },
        {
            field: 'isProviderSigned',
            headerName: 'Provider',
            flex: 1,
            minWidth: 110,
            renderCell: (params) => params.row?.isProviderSigned ?
                <span className='complete'><SVGIcons.TickIcon /> Signed</span> :
                <span className='pending'><SVGIcons.ClockCountdownIcon /> Pending</span>,
        },
        {
            field: 'id',
            headerName: 'Actions',
            flex: 0.8,
            minWidth: 90,
            sortable: false,
            renderCell: ({ row }) => {
                const { id, logTitle, logKey } = row
                return <AppPopOverMenu options={[
                    {
                        label: 'View',
                        onClick: () => onFormPreviewClick(logKey, row)
                    },
                    {
                        label: "Download",
                        onClick: () => downloadDailyLogPDF(id, logTitle)
                    }
                ]} />
            }
        },

    ]




    return (
        <>

            <div style={{ width: '100%' }} className="table-sec-wrp f-wrp">
                <div className='panel-table-sec parent-table PC-Table f-wrp'>
                    <AppTable
                        columns={tableColumns}
                        isLoading={isLoading}
                        data={dataArr}
                    />
                    <div className='mob-table-wrp childView f-wrp'>
                    {dataArr.length > 0 ? <ul>
                            {dataArr.map((element) => (
                                <li key={element.id}>
                                    <div className='each-sec-box'>
                                        <h4>{dayjs(element.submissionDate).format(DATE_ONLY_FORMAT)}</h4>
                                        <h4>{dayjs(element.submissionDate).format(MONTH_TEXT_FORMAT)}</h4>
                                    </div>
                                    <div className='each-sec-box'>
                                        <h4>{element.childId?.firstName}&nbsp;{element.childId?.lastName}</h4>
                                        <span>{element.logTitle}</span>
                                        <p className='flex-wrp'> {translateThis('Provider')}: {element.isProviderSigned ?
                                            <span className='status complete'>{translateThis('Signed')}</span> :
                                            <span className='status pending'>{translateThis('Pending')}</span>}</p>
                                    </div>
                                    <div className='each-sec-box'>
                                        <ul className='btn-wrp'>
                                            {/* <li><button className='pln-btn ForwardIcon' type='button' onClick={() => { onFormPreviewClick(element.logKey, element) }}><SVGIcons.ForwardIcon /></button></li> */}
                                            <li><button className='pln-btn' type='button' onClick={() => { downloadDailyLogPDF(element.id, element.logTitle) }}><SVGIcons.DownloadIcon /></button></li>
                                        </ul>
                                        <span>{element.isParentSigned ?
                                            <span className='status complete'>{translateThis('Signed')}</span> :
                                            <AppButton
                                                onClick={() => {
                                                    setOpenSubmissionDialog(true);
                                                    setSelectedId(element.id);
                                                }}
                                                btnText='Sign'
                                            />}</span>
                                    </div>
                                    <Link className='full-li-btn' onClick={() => { onFormPreviewClick(element.logKey, element) }} />
                                </li >
                            ))}
                        </ul> : <div className='empty-placeholder f-wrp'>
                            <div className='placeholder-con'>
                                <img src={AppIcons.placeholder} alt='empty' />
                                <h4>{translateThis('File not found')}</h4>
                            </div>
                        </div>
                        }
                    </div>
                </div>
                {openSubmissionDialog && <ConfirmDialog
                    isOpen={openSubmissionDialog}
                    onClose={() => {
                        setOpenSubmissionDialog(false);
                        setSelectedId('');
                        setSignature('');
                    }}
                    title={`Log submission signature`}
                    className={'delete-popup'}
                    description={<div>
                        <TextInput
                            key={`parent_signature`}
                            label={translateThis('typeYourName')}
                            name='parent_signature'
                            id='parent_signature'
                            value={signature}
                            type='text'
                            required
                            placeholder={translateThis('typeYourName')}
                            className='custom-textfield'
                            getValue={(_, value) => {
                                setSignature(value)
                            }}
                            useDefaultValidation
                        />
                        <br />
                        <span>
                            By clicking this checkbox you confirm you have read and accepted the submission made by the parent. <span style={{ color: '#FF3D00' }}> This action cannot be undone.</span>
                        </span>
                    </div>}
                    okayButtonText={'Sign form'}
                    confirmButton={
                        <AppButton
                            onClick={submitDailyLog}
                            isDisabled={signature.length < 2}
                            btnText={translateThis('signForm')}
                            isLoading={isSubmitting}
                        />
                    }
                />}
            </div>
            {viewOpen ? <ModalPopUp
                className='preview-popup'
                isOpen={viewOpen}
                onClose={onViewClose}
                aria-labelledby="table-view"
                aria-describedby="table-view"
            >
                {selectedPreview}
                <Button onClick={onViewClose} className='fill-btn'>Close</Button>
            </ModalPopUp> : null}
        </>
    )
}


export default DailyLogToSignTab;